import React from 'react';
import { UserAccount } from '../components/UserAccount';
import { useNavigate } from 'react-router-dom';

export function AccountPage() {
  const navigate = useNavigate();

  return (
    <UserAccount onBack={() => navigate('/recipes')} />
  );
}